import { useEffect, useState } from 'react';
import { ThemeProvider } from '@emotion/react';
import { useDispatch, useSelector } from 'react-redux';
import { UPDATE } from 'shared/wizard/actions';
import Overview from './Overview';
import defaultTheme from 'shared/defaultTheme';
import { getSettings } from '../helpers';
import { Footer, OverviewContainer } from 'shared/containers';
import { Disclaimer } from 'shared/wizard';
import { ToolLoader, HypotheekbondLogo, InternalServerError } from 'shared/components';

const App = () => {
  const [theme, setTheme] = useState(defaultTheme);
  const dispatch = useDispatch();
  const { settings, broken } = useSelector(state => state);

  useEffect(() => {
    getSettings(data => {
      dispatch({
        type: UPDATE,
        payload: { settings: data },
      });
      setTheme({ ...theme, ...data });
    });
  }, []);

  const BrokenLayout = () => (
      <div
        css={{
          display: 'flex',
          justifyContent: 'center',
          margin: '32px 0',
        }}
      >
        <InternalServerError />
      </div>
  );

  if (!settings) return <ToolLoader />;
  return (
    <ThemeProvider theme={theme}>
      {broken ? (
        <BrokenLayout />
      ) : (
        <OverviewContainer>
          <Overview />
          <Footer>
            {settings.enableDisclaimer && <Disclaimer settings={settings} />}
            {settings.enableHypotheekbondLogo && <HypotheekbondLogo />}
          </Footer>
        </OverviewContainer>
      )}
      </ThemeProvider>
  );
};

export default App;
